import GlobalStyles from './styles/global';
import { AppThemeContextProvider } from './contexts/theme';
import { BrowserRouter } from 'react-router-dom';
import AppProvider from './contexts';
import { ToastProvider } from './contexts/toast';
import { CourseProvider } from './contexts/course';
import { ModalProvider } from './contexts/modal';
import Layout from './components/Layout';


function App() {

  return (
    <BrowserRouter basename='/student'>
      <AppProvider>
        <AppThemeContextProvider>
          <GlobalStyles />
          <ToastProvider>
            <CourseProvider>
              <ModalProvider>
                <Layout />
              </ModalProvider>
            </CourseProvider>
          </ToastProvider>
        </AppThemeContextProvider>
      </AppProvider>
    </BrowserRouter>
  );
}

export default App;
